<template>
  <div class="">
    <div class="flex flex-row items-start justify-center">
      <div class="md:basis-1/2 grow   " v-show="state === 'selection'">
        <div class="flex flex-row  ">
          <div class="basis-1/2   wrap  text-left justify-start text-[#307946] font-bold ">
            SELECT TYPE OF <br class="md:hidden"> PLANT
          </div>
          <div class="basis-1/2 text-left text-[#307946] font-bold ">
            NUMBER OF ACRES
          </div>
        </div>
        <!-- select -->
        <div class="flex flex-row " v-for="x in lists" :key="x.plant">
          <div class="basis-1/2 grow justify-left pr-4 sm:pr-2 pt-4 ">
            <div class="pa-4 " >
              <select  v-model="x.content"  aria-placeholder="Plant Type" class="border-gray-200 border-2  mt-1 block w-full rounded-md border-3 py-2 pl-1 md:pl-3 pr-2 md:pr-10 text-base focus:border-indigo-500 focus:outline-none  sm:text-sm">
                <option :value="{}" hidden>Plant Type</option>
                <option  v-for="y in plants" :value="{id: y.id, name: y.name, price: y.price} " :key="y.name" >{{y.name}}</option>
              </select>
            </div>
          </div>
          <div class="basis-1/2 grow pr-4 pt-4">
            <div class="pa-4" >
              <select v-model="x.acres" aria-placeholder="Acres" class="border-gray-200 border-2  mt-1 block w-full rounded-md border-3 py-2 pl-3 pr-10 sm:pr-2 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                <option :value="{}" hidden>Acres</option>
                <option v-for="(y, index) in acres" :value="y" :key="index" >{{y}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="flex flex-row justify-end">
          <button @click="removeList" type="button" class="inline-flex items-center font-weight-600 px-3 py-2 text-xl font-bold leading-4 text-black   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">-</button>
          <button @click="addList" type="button" class="inline-flex items-center font-weight-600 px-3 py-2 text-xl font-bold leading-4 text-[#307946]   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">+</button>
        </div>
        <div class="flex flex-row justify-end">
          <button @click="toggle('result')" type="button" class="inline-flex items-center font-weight-600 px-3 py-2 text-xl font-bold leading-4 text-[#307946]   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            <img width="24px" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
            <span class="pl-1">Calculate</span>
          </button>
        </div>
      </div>
      <div class="basis-1/2 grow md:basis-1/2 " v-show="state === 'result'">
        <div class="text-[#307946] pb-10 flex flex-row justify-center font-bold">
          <div class="basis-1/2 md:basis-1/3 grow  text-left">
            TYPE
          </div>
          <div class="basis-1/2 md:basis-1/3 grow text-left ">
            ACRES
          </div>
          <div class="basis-1/3 grow  "></div>
        </div>
        <!-- select -->
        <div class="flex flex-row  border-b-2 pt-2 pb-2 border-green-900 " v-for="x in clean" :key="x.name" v-show="x.acres">
          <div class="basis-1/2 md:basis-1/3 grow  text-[#307946]">
            <div class=" border-indigo-500 text-left" >
              {{x.content.name}}
            </div>
          </div>
          <div class="basis-1/3 grow">
            <div class=" border-indigo-500 text-left indent-6" >
              {{x.acres}}
            </div>
          </div>
          <div class="basis-1/2 md:basis-1/3 grow">
            <div class=" border-indigo-500 text-left " >
              {{(x.content.price * x.acres).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} THB
            </div>
          </div>
        </div>
        <div class="text-[#307946] flex flex-row pt-2 pb-2  font-bold">
          <div class="basis-1/2 md:basis-1/3 grow text-left ">
            TOTAL
          </div>
          <div class="basis-1/3 grow text-left ">

          </div>
          <div class="basis-1/2 md:basis-1/3 grow  text-left">
            {{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}  THB
          </div>
        </div>
        <div class="flex flex-row justify-end">
          <button @click="toggle('selection')" type="button" class="inline-flex items-center font-weight-600 px-3 py-2 text-xl font-bold leading-4 text-[#307946]   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            <img width="24px" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
            <span class="pl-1">Make Changes</span>
          </button>
        </div>
      </div>
    </div>
    <!-- calculator -->
    <!-- display -->
  </div>
</template>

<script>

export default {
  watch: {
    lists: function () {
      const temp = this.lists
      this.clean = temp.filter(x => !(typeof x.acres === 'object') && (x.content.name !== undefined))
      if (this.clean.length === 1) {
        this.total += (this.clean[0].content.price * this.clean[0].acres)
      } else {
        this.total = 0
        this.clean.map(x => {
          this.total += x.content.price * x.acres
        })
      }
    },
    deep: true
  },
  methods: {
    calculate () {
      const temp = this.lists
      this.clean = temp.filter(x => !(typeof x.acres === 'object') && (x.content.name !== undefined))
      if (this.clean.length === 1) {
        this.total += (this.clean[0].content.price * this.clean[0].acres)
      } else {
        this.total = 0
        this.clean.map(x => {
          this.total += x.content.price * x.acres
        })
      }
    },
    removeList () {
      this.lists.pop()
    },
    addList () {
      this.lists.push({content: {}, acres: 0})
    },
    toggle (state) {
      this.calculate()
      if (this.clean.length === 0) {
        alert('Please fill all the information')
        return
      }
      this.state = state
    }
  },
  name: 'HelloWorld',
  data () {
    return {
      clean: [],
      cursor: require('../assets/cursor.svg'),
      total: 0,
      state: 'selection',
      // 1,119,614
      plants: [
        {name: 'Organic Vegetable', price: 70000},
        {name: 'Kratom', price: 1000000},
        {name: 'Little Cone Mushroom', price: 10000},
        {name: 'Hemp Seed', price: 13419},
        {name: 'Hemp Fiber', price: 10918},
        {name: 'Hemp Flower', price: 15277}

      ],
      acres: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      lists: [
        {content: {}, acres: {}},
        {content: {}, acres: {}},
        {content: {}, acres: {}},
        {content: {}, acres: {}}
      ],
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue